// React Component以外でcookieを扱うためのutility
import Cookies from 'universal-cookie'

export const resetUserCookies = () => {
  const cookies = new Cookies(null, { path: '/' })
  cookies.remove('user_hash')
  cookies.remove('coin_counts')
  cookies.remove('point_counts')
}
